import clsx from 'clsx';

type Props = {
  /** loading = スケルトン（pulse）/ empty = 薄いプレースホルダ＋メッセージ */
  variant: 'loading' | 'empty';
};

const BAR_HEIGHTS = [39, 84, 56, 100, 75, 50, 72, 58, 91, 66, 80, 48];

/**
 * - 6 本の点線グリッド線
 * - 高さの異なるグレーの棒（loading は pulse、empty は静的な薄いグレー）
 * - empty のときは中央に「表示するデータがありません」を重ねる
 */
export default function DashboardFunnelChartPlaceholder({ variant }: Props) {
  const isLoading = variant === 'loading';

  return (
    <div className="relative h-[184px] w-full px-md pt-md">
      {/* グリッド線 */}
      <div className="absolute inset-x-md top-md bottom-lg flex flex-col justify-between">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="border-t border-dashed border-border" />
        ))}
      </div>

      {/* 棒 */}
      <div className="absolute inset-x-md bottom-lg flex items-end justify-between gap-xs">
        {BAR_HEIGHTS.map((h, i) => (
          <div
            key={i}
            style={{ height: `${h}px` }}
            className={clsx(
              'w-[50px] shrink rounded-t-sm bg-medium-gray',
              isLoading && 'animate-pulse'
            )}
          />
        ))}
      </div>

      {/* データなしメッセージ */}
      {!isLoading && (
        <div className="absolute inset-x-0 top-md flex justify-center">
          <p className="text-base leading-[1.7] text-sub">表示するデータがありません</p>
        </div>
      )}
    </div>
  );
}
